import React, { useRef, useState } from "react";
import { leaf, leaf2, mainLeaf } from "../../assets";
import { BsBookmarkPlus } from "react-icons/bs";
import { motion } from "framer-motion";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Appointment = () => {
  const [selectColor, setSelectColor] = useState(true);
  const [dateColor, setDateColor] = useState(true);

  const [fullName, setFullName] = useState("");
  const [num, setNum] = useState("");
  const [doc, setDoc] = useState("");
  const [date, setDate] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [payMethod, setPayMethod] = useState("");
  const [popup, setPopup] = useState(false);

  const [allData, setAllData] = useState({
    fullName: "",
    phone: "",
    doctor: "",
    date: "",
    message: "",
    userEmail: "",
    payMethod: "",
  });

  const form = useRef();
  const checkBox = useRef();

  const changleSelect = (e) => {
    setSelectColor(false);
    setDoc(e.target.value);

    if (e.target.value === "select") {
      setSelectColor(true);
    }
  };

  const handleDate = (e) => {
    setDate(e.target.value);
    setDateColor(false);
  };

  const reset = () => {
    setFullName("");
    setNum("");
    setDoc("");
    setDate("");
    setMessage("");
    setEmail("");
    setPayMethod("");
  };

  const submitForm = (e) => {
    e.preventDefault();

    if (doc !== "" && payMethod !== "") {
      setAllData({
        fullName: fullName,
        phone: num,
        doctor: doc,
        date: date,
        message: message,
        userEmail: email,
        payMethod: "cod",
      });

      setPopup(true);
    } else {
      alert("Please select all field");
    }
  };

  const submitPayment = (e) => {
    e.preventDefault();

    if (doc !== "" && payMethod !== "") {
      fetch("https://laser-treat-server.onrender.com//ssl-init", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullName: fullName,
          phone: num,
          doctor: doc,
          date: date,
          message: message,
          userEmail: email,
          payMethod: "online payment",
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          window.location.replace(data?.url);
        });

      reset();

      checkBox.current.checked = false;
    } else {
      alert("Please Select all field");
    }
  };

  const handleConfirm = () => {
    setPopup(false);
    toast.success(
      `Appointment has been booked successfully Mr./Mrs. ${fullName}`,
      {
        position: "top-center",
        autoClose: 3000,
      }
    );

    reset();

    checkBox.current.checked = false;

    //post on DB
    fetch("https://laser-treat-server.onrender.com/bookings/save", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(allData),
    });
  };

  const handleCancel = () => {
    setPopup(false);
    reset();

    checkBox.current.checked = false;
  };
  return (
    <motion.div
      whileInView={{ opacity: [0, 1], y: [50, 0] }}
      transition={{ duration: 0.7 }}
      id="appointment"
    >
      <div className="gradient"></div>
      <img src={leaf2} className="mainLeaf" alt="" />
      <img src={mainLeaf} className="mainLeaf2" alt="" />

      {popup && (
        <div className="popupBooking">
          <motion.div
            whileInView={{ opacity: [0, 1], y: [50, 0] }}
            transition={{ duration: 0.7 }}
            className="content"
          >
            <p>Are you sure to confirm a booking with {doc} ?</p>
            <div className="popBtn">
              <button onClick={handleConfirm}>Confirm</button>
              <button className="cancel" onClick={handleCancel}>
                Cancel
              </button>
            </div>
          </motion.div>
        </div>
      )}

      <div className="textArea">
        <img src={leaf} alt="" />
        <h1>Schedule an Appointment</h1>
        <p>
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aperiam,
          voluptas!
        </p>
      </div>

      <div className="formArea">
        <form
          ref={form}
          onSubmit={payMethod === "cod" ? submitForm : submitPayment}
        >
          <div className="inputs">
            <p>Hey, my name is </p>
            <input
              required
              type="text"
              placeholder="Enter your name"
              name="from_fullName"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
            <p>Phone </p>
            <input
              required
              type="tel"
              placeholder="Enter your Number"
              name="from_num"
              value={num}
              onChange={(e) => setNum(e.target.value)}
            />
            <p>and I'm looking for an appointment with</p>
            <select
              required
              onChange={changleSelect}
              name="from_doc"
              value={doc}
              className={!selectColor ? "changedColor" : ""}
            >
              <option value="select">Select Doctor</option>
              <option>DR. SARKER MAHBUB AHMED SHAMIM</option>
              <option>Dr. Dilruba Sharmin</option>
              <option>Dr. Rabeya Afroz Shoma</option>
              <option>Dr. Salma Sumi</option>
              <option>Dr. Saymun Jesmin</option>
              <option>Dr. Shamma Binte Hafiz</option>
              <option>Dr. Shumana Sharmin</option>
              <option>Dr. Sonia Sharmin</option>
              <option>Dr. A.S.M Raquibul Islam Akash</option>
            </select>
            <p>on </p>
            <input
              required
              type="date"
              onChange={(e) => handleDate(e)}
              className={dateColor ? "dateInp" : "dateInpBlack"}
              name="from_date"
              value={date}
            />
            <p>for the reason </p>
            <textarea
              required
              placeholder="Enter your Message"
              name="from_message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <p>Get in touch with me at </p>
            <input
              required
              type="email"
              placeholder="Enter your Email"
              name="from_email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <p>!</p>
          </div>

          <div className="payment-method">
            <p>Choose a Payment Method: </p>
            <div className="radio-el">
              <label>
                <input
                  type="radio"
                  name="payment-type"
                  value="cod"
                  onChange={(e) => setPayMethod(e.target.value)}
                />
                COD
              </label>
              {/* <label>
                <input
                  type="radio"
                  name="payment-type"
                  value="online"
                  onChange={(e) => setPayMethod(e.target.value)}
                />
                Online Payment
              </label> */}
            </div>
            {payMethod === "online" && (
              <p>
                Appointment Charge <span>BDT 500/-</span>
              </p>
            )}
          </div>

          <div className="accept">
            <input required type="checkbox" name="" id="" ref={checkBox} />
            <p>I here by accept all terms and conditions.</p>
          </div>

          {payMethod === "cod" ? (
            <button type="submit" className="submit_button">
              Book my appointment
            </button>
          ) : (
            <button
              type="submit"
              className={`submit_button ${payMethod === "online" && "sslPay"}`}
            >
              
              {payMethod === "online"
                ? "Pay & Book appointment"
                : "Book my appointment"}
            </button>
          )}
        </form>
      </div>

      <ToastContainer />
    </motion.div>
  );
};

export default Appointment;
